/**
 * Focus In Element Function
 * @param {string} selector The query selector of the element. eg.: #my-element
 * @param {{timeout?: number, preventScroll?: boolean}} [options] An object with the focus options. There are two options, `timeout` that is the delay to focus in element and `preventScroll` that is a boolean value indicating whether or not the browser should scroll the document to bring the newly-focused element into view.
 */

const focusInElement = (selector, options = {}) => {
  const timeout = options.timeout || 100
  const preventScroll = options.preventScroll || false

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const el = document.querySelector(selector)
      if (el) {
        el.focus({ preventScroll })
        return resolve(el)
      }

      return reject(el)
    }, timeout)
  })
}

module.exports = focusInElement
